// All components
import {
  Dialog,
  Autocomplete,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  DatePicker,
  Popover,
  Tooltip,
  MessageBox,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Alert,
  Notification,
  Loading,
  Icon,
  Row,
  Col,
  Message,
  Card,
  Collapse,
  CollapseItem,
  Cascader,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Link,
  CascaderPanel,
} from 'element-ui'
import locale from 'element-ui/lib/locale'
import Pagination from '@/components/element-ui/pagination'
import TableColumn from '@/components/element-ui/table-column'

const components = [
  Dialog,
  Autocomplete,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  DatePicker,
  Popover,
  Tooltip,
  MessageBox,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Alert,
  Notification,
  Icon,
  Row,
  Col,
  Message,
  Card,
  Collapse,
  CollapseItem,
  Cascader,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Link,
  CascaderPanel,
]

export default function install(Vue, opts = {}) {
  locale.use(opts.locale)
  locale.i18n(opts.i18n)

  components.forEach(component => {
    Vue.component(component.name, component)
  })

  // custom components
  Vue.component('ElPagination', Pagination)
  Vue.component('ElTableColumn', TableColumn)

  // Vue.use(InfiniteScroll)
  Vue.use(Loading.directive)

  Vue.prototype.$ELEMENT = {
    size: opts.size || '',
    zIndex: opts.zIndex || 2000
  }

  function $alert(msg, t, opt, invoke) {
    let title = t
    let options = opt

    if (title === undefined && options === undefined) {
      title = '提示'
      options = { type: 'warning', showClose: false }
    } else if (typeof title === 'object') {
      options = title
      title = '提示'
    }

    return MessageBox[invoke](msg, title, options)
  }

  // 重写 Vue.prototype.$alert, Vue.prototype.$confirm 方法，加入默认 title, icon
  Vue.prototype.$alert = function alert(msg, title, options) {
    return $alert(msg, title, options, 'alert')
  }

  Vue.prototype.$confirm = function confirm(msg, title, options) {
    return $alert(msg, title, options, 'confirm')
  }

  Vue.prototype.$loading = Loading.service
  Vue.prototype.$msgbox = MessageBox
  // Vue.prototype.$alert = MessageBox.alert
  // Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
  Vue.prototype.$notify = Notification
  Vue.prototype.$message = Message
}
